module.exports = __webpack_public_path__ + "img/CQL_logo_kombi.49f4a2f9.svg";